import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.02 4.354a.5.5 0 1 0-.707-.708L5.98 9.98l-.647.646-2.98-2.98a.5.5 0 1 0-.707.708l3.334 3.333a.5.5 0 0 0 .707 0l.646-.647.647.647a.5.5 0 0 0 .707 0l7.333-7.333a.5.5 0 1 0-.707-.708l-6.98 6.98-.293-.293z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }